<script setup>

import Button from "primevue/button";
import ls from "localstorage-slim";
import {onMounted, ref} from "vue";

const darkMode = ref(false);

const toggleDarkMode = () => {
    ls.set('darkMode', !darkMode.value);
    setDarkMode(!darkMode.value);
    darkMode.value = !darkMode.value;
}

const setDarkMode = (value) => {
    const element = document.querySelector('html');
    element.classList.toggle('configurator-dark', value);
}

onMounted(() => {
    const val = ls.get('darkMode')
    if (val !== darkMode.value) {
        darkMode.value = val;
        setDarkMode(val);
    }
});

</script>

<template>
    <Button text class="hidden md:block" @click="toggleDarkMode()">
       <i class="material-icons"> {{ darkMode ? 'light_mode' : 'dark_mode' }}</i>
    </Button>
</template>
